import React from "react";
import { cssTransition } from "react-toastify";

export const Fade = cssTransition({ enter: "fadeIn", exit: "fadeOut" });
